<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12" style="margin-top: 10px">
                        <span class="title">创建时间:</span>

                        <el-date-picker
                            v-model="create_fixed_array"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 300px"
                        >
                        </el-date-picker>
                    </el-col>

                    <el-col :span="12">
                        <span class="title">名称:</span>
                        <!-- 搜索名称 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入名称"
                            class="handle-input mr10"
                            @keyup.enter.native="searchcardLists"
                        ></el-input>
                    </el-col>
                </el-row>

                <el-row class="head-search">
                    <el-col :span="8">
                        <span class="title">状态:</span>

                        <el-select v-model="search_data.status" placeholder="请选择状态" clearable @keyup.enter.native="searchcardLists">
                            <el-option label="上架" value="1"> </el-option>
                            <el-option label="下架" value="0"> </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchcardLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">重置</el-button>
            <el-button @click="add_isShow = !add_isShow">添加</el-button>
            <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
            <el-button @click="toExport" v-else>导出</el-button>
            <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...
            </div>
        </div>
        <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column label="名称" prop="name" min-width="130"> </el-table-column>

            <el-table-column label="创建时间" prop="created_at" min-width="160"> </el-table-column>

            <el-table-column label="有效期（天）" prop="expire" min-width="110"> </el-table-column>

            <el-table-column label="价格" prop="price" min-width="90"> </el-table-column>

            <el-table-column label="限制次数" prop="limit_num" min-width="90"> </el-table-column>

            <el-table-column label="销量" prop="sell_num" min-width="80"> </el-table-column>

            <el-table-column label="抵扣规则" prop="type" min-width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.type == '1' ? 'success' : 'warning'">
                        {{ scope.row.type == '1' ? '免订单金额' : '免起步价格' }}</el-tag
                    >
                </template>
            </el-table-column>
            <el-table-column label="上架下架状态" prop="status" min-width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status == '1' ? 'success' : 'warning'">
                        {{ scope.row.status == '1' ? '上架' : '下架' }}</el-tag
                    >
                </template>
            </el-table-column>
            <el-table-column label="启用禁用状态" prop="state" min-width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.state == '1' ? 'success' : 'warning'"> {{ scope.row.state == '1' ? '启用' : '禁用' }}</el-tag>
                </template>
            </el-table-column>
           
            <el-table-column label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        @click="
                            view_isShow = !view_isShow;
                            card_code = scope.row.card_code;
                        "
                        trigger="click"
                    >
                        查看

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="sendPriorityFuntion(scope.row)"> 发放 </el-dropdown-item>
                            <div>
                                <el-dropdown-item v-if="scope.row.state == 0" @click.native="is_state(1, 1, scope.row.card_code)">
                                    启用
                                </el-dropdown-item>
                                <el-dropdown-item v-else @click.native="is_state(1, 0, scope.row.card_code)"> 禁用 </el-dropdown-item>
                            </div>
                            <div>
                                <el-dropdown-item v-if="scope.row.status == 0" @click.native="is_state(2, 1, scope.row.card_code)">
                                    上架
                                </el-dropdown-item>
                                <el-dropdown-item v-else @click.native="is_state(2, 0, scope.row.card_code)"> 下架 </el-dropdown-item>
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加组件 -->
        <addCardDrawer :isShow="add_isShow" @onSubmit="cardLists"></addCardDrawer>

        <!-- 查看组件 -->
        <viewCardDrawer :isShow="view_isShow" :data="card_code"></viewCardDrawer>
        <!-- 发放组件 -->
        <sendCard :isShow="edit_isShow" :data="card_code" @onSubmit="cardLists"></sendCard>
    </div>
</template>

<script>
var _this;
import bus from '@/components/common/bus.js';
import addCardDrawer from './addCardDrawer.vue';
import sendCard from './sendCard.vue';

import viewCardDrawer from './viewCardDrawer.vue';
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置
export default {
    components: {
        addCardDrawer,
        sendCard,
        viewCardDrawer
    },
    data() {
        return {
            edit_isShow: false,

            excelData: [],

            excelHead: [],

            progress_show: false,
            progress_data: 0,

            loading: false,

            create_fixed_array: '',
            add_isShow: false,

            view_isShow: false,

            // 存放表格数据
            tableData: [],

            card_code: '',

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                status: '',
                create_fixed_array: '',
                card_code_array: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        bus.$on('btnStatus', (msg) => {
            _this.progress_show = msg;
        });
        _this.cardLists();
    },

    methods: {
        sendPriorityFuntion(val) {
            _this.edit_isShow = !_this.edit_isShow;
            _this.card_code = val.card_code; //子组件data值
        },
        // state,e==1启用或者禁用 上架下架status,e==2方法
        is_state(e, val, code) {
            let postData;
            if (e == 1) {
                postData = {
                    state: val,
                    status: '',
                    card_code: code
                };
            } else if (e == 2) {
                postData = {
                    state: '',
                    status: val,
                    card_code: code
                };
            }

            _this.aaa(postData);
        },
        aaa(obj) {
            _this
                .$post('/card/editCard', obj)
                .then((res) => {
                    this.$message.success(res.msg);
                    _this.cardLists();
                })
                .catch((err) => {});
        },

        // 导出
        toExport() {
            _this.progress_show = true;
            _this.search_data.page = 1;
            _this.getExcelData();
        },

        getExcelData() {
            _this
                .$post('/card/cardLists', _this.search_data)
                .then((res) => {
                    _this.progress_show = true;

                    if (this.$route.path == '/Card') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            console.log(res.data[i].order_code);
                            _this.excelData.push({
                                name: res.data[i].name,
                                created_at: res.data[i].created_at,
                                expire: res.data[i].expire,
                                price: res.data[i].price,
                                limit_num: res.data[i].limit_num == 0 ? '无限' : res.data[i].limit_num,
                                sell_num: res.data[i].sell_num,
                                type: res.data[i].type == '1' ? '免订单金额' : '免起步价格',
                                state: res.data[i].state == '1' ? '启用' : '禁用',
                                status: res.data[i].status == '1' ? '上架' : '下架'
                            });
                        }

                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            _this.search_data.page = _this.search_data.page + 1;

                            _this.progress_data = Math.floor(((_this.search_data.page * _this.search_data.limit) / res.count) * 100);

                            _this.getExcelData();
                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['名称', '创建时间', '有效期（天）', '价格', '限制次数', '销量', '抵扣规则', '启用禁用状态', '上架下架状态'];

            const filterVal = ['name', 'created_at', 'expire', 'price', 'limit_num', 'sell_num', 'type', 'state', 'status'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            let time = new Date();
            console.log(time);
            console.log(time.toLocaleDateString());
            export_json_to_excel(tHeader, data, '畅行卡' + time.toLocaleDateString());
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        // 全选或多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);

            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].card_code);
            }
            _this.search_data.card_code_array = datalist;
            console.log(datalist);
        },
        timeChange(val) {
            console.log(val);

            if (val != null) {
                _this.search_data.create_fixed_array = JSON.stringify(['between', ..._this.create_fixed_array]);
            } else {
                _this.search_data.create_fixed_array = '';
            }
        },

        searchcardLists() {
            _this.search_data.page = 1;
            _this.cardLists();
        },

        cardLists() {
            _this
                .$post('/card/cardLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.cardLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>